import React, { FunctionComponent, memo } from "react";
import { isEqual } from "lodash";

import { IAlgorithmReport } from "../../algorithm/types";

import AlgorithmReports from "../../algorithm/AlgorithmReports";


interface IProps{
  reports: IAlgorithmReport[];
}


const SourceReports: FunctionComponent<IProps> = memo(function SourceReports({
  reports,
}) {
  return <>
    <AlgorithmReports reports={reports} />
  </>
}, isEqual);

export default SourceReports;
